// extracted by mini-css-extract-plugin
export var dropdownContainer = "_ps-0";
export var leftAlign = "_ps-4";
export var listItem = "_ps-2";
export var listItemWrapper = "_ps-1";
export var operationText = "_ps-3";